
import KnxGenerateProjectService from "../knx_ausstattung/GenerateProjectService";
import products from "../../data/products";

export default function GenerateProjectService(projectIn, productList){

    return KnxGenerateProjectService(projectIn, products);

}
